// extracted by mini-css-extract-plugin
export default {"wrapper":"Maintenance_wrapper__-F43t"};